import React from 'react';
import classNames from 'classnames';
import { getYear } from 'date-fns';
import styles from '../../assets/css/booking.module.css';
import TextInput from '../../common/TextInput';
import CustomDatePicker from '../../common/CustomDatePicker';
import SelectInput from '../../common/SelectInput';
import LoadingSpinner from '../../common/LoadingSpinner';
import AutocompleteInput from '../../common/AutocompleteInput';
import LuggageInput from '../LuggageInput';
import Slices from '../../Offers/Slices';
import { BAGS_TYPES, GENDERS } from '../../constants';

const FreeLuggage = ({ weight, count, baggageType, reference }) =>(
  <div className={styles.luggage_info}>

    {!!count && <>
      <p>{
        reference.includes('2Pc')
          ? 'حقيبتين' : !reference.includes('2Pc') ? 'حقيبة'
            : count + ' حقائب'}
      </p>
      <p>{BAGS_TYPES[baggageType].label}
      </p>
    </>
    }
    {!!weight && <p>
      {weight} كجم
    </p>
    }
    <span className="iconify" data-icon={BAGS_TYPES[baggageType].icon}></span>
  </div>
);

const BaseForm = ({
  meta: { countries } = {},
  passenger = {},
  booking,
  handleChange,
  isFirstPassenger,
  errors,
  order,
  toggleBagSelect,
  handleBookingChange
}) => {
  return (
    <form id="passenger_info_form" className={styles.passenger_info_form}>
      {
        isFirstPassenger && <>
          <p className={styles.container_title}>بيانات  التواصل</p>
          <div className={classNames(styles.container, styles.input_container)} style={errors ? { alignItems: 'flex-start' } : { alignItems: 'flex-end' }}>
            <TextInput
              label="رقم الهاتف"
              icon={<span className="iconify" data-icon="tabler:phone-filled"></span>}
              placeholder="رقم الهاتف كاملا مع مفتاح الدولة"
              value={booking.mobile}
              onChange={({ target: { value } }) => handleBookingChange({ mobile: value })}
              error={errors.mobile}
            />

            <TextInput
              label="عنوان البريد الإلكتروني"
              icon={<span className="iconify" data-icon="tabler:mail-filled"></span>}
              placeholder="example@example.com"
              value={booking.email}
              onChange={({ target: { value } }) => handleBookingChange({ email: value })}
              error={errors.email}
            />
          </div>
        </>
      }
      <div className={styles.passenger_type}>
        <div>
          <p className={styles.container_title}>{isFirstPassenger ? 'بيانات المسافر الرئيسي' : `بيانات المسافر ${order}`}</p>
          <p className='note'>* الرجاء إدخال بيانات المسافر باللغة الإنجليزية</p>
        </div>

        {passenger.passengerType === 'adult' && <div className={styles.passenger_type_icon}>
          <p>بالغ</p><i className="fas fa-male"></i>
        </div>}

        {passenger.passengerType === 'child' && <div className={styles.passenger_type_icon}>
          <p>طفل</p><i className="fas fa-child"></i>
        </div>}

        {passenger.passengerType === 'infant' && <div className={styles.passenger_type_icon}>
          <p>رضيع</p><i className="fas fa-baby"></i>
        </div>}
      </div>

      <div className={styles.container} >
        <div className={styles.multiple_input_rows}>
          <div className={styles.input_container} style={errors ? { alignItems: 'flex-start' } : { alignItems: 'flex-end' }}>
            <TextInput
              label="الإسم الأول"
              type="text"
              placeholder="الإسم الأول"
              value={passenger.firstName}
              error={errors[`${passenger.id}.firstName`]}
              onChange={({ target: { value } }) => handleChange({ firstName: value })}
            />
            <TextInput
              label="الإسم الأخير"
              type="text"
              placeholder="الإسم الأخير"
              value={passenger.lastName}
              error={errors[`${passenger.id}.lastName`]}
              onChange={({ target: { value } }) => handleChange({ lastName: value })}
            />

            <div className='simple-date-picker'>
              <p className='datepicker-label'>تاريخ الميلاد</p>
              <CustomDatePicker selected={passenger.dateOfBirth} onChange={(date) => handleChange({ dateOfBirth: date })} placeholderText="yyyy-mm-dd" dateFormat="yyyy-MM-dd" startDate="1900"
              />
              <span className="error-message">{errors[`${passenger.id}.dateOfBirth`]}</span>
            </div>

          </div>

          <div className={styles.input_container} style={errors ? { alignItems: 'flex-start' } : { alignItems: 'flex-end' }}>
            <SelectInput
              style={{ margin: '0 5px' }}
              label="الجنس"
              title="الجنس"
              list={GENDERS}
              value={passenger.gender}
              error={errors[`${passenger.id}.gender`]}
              onChange={(value) => handleChange({ gender: value })}
            />
            <AutocompleteInput
              value={passenger.placeOfBirth}
              label="مكان الميلاد"
              placeholder="مكان الميلاد"
              list={countries}
              error={errors[`${passenger.id}.placeOfBirth`]}
              onChange={(value) => handleChange({
                placeOfBirth: value
              })}
            />

            <AutocompleteInput
              label="الجنسية"
              placeholder="الجنسية"
              list={countries}
              value={passenger.nationalityCountry}
              error={errors[`${passenger.id}.nationalityCountry`]}
              onChange={(value) => handleChange({
                nationalityCountry: value
              })}
            />

          </div>

          <div className={styles.input_container} style={errors ? { alignItems: 'flex-start' } : { alignItems: 'flex-end' }}>
            <TextInput
              label="رقم جواز السفر"
              type="text"
              name="documentNumber"
              placeholder="A-Z 00000000"
              value={passenger.documentNumber}
              error={errors[`${passenger.id}.documentNumber`]}
              onChange={({ target: { value } }) => handleChange({ documentNumber: value })}
            />

            <AutocompleteInput
              label="بلد إصدار جواز السفر"
              placeholder="بلد إصدار جواز السفر"
              list={countries}
              value={passenger.documentIssuanceCountry}
              error={errors[`${passenger.id}.documentIssuanceCountry`]}
              onChange={(value) => handleChange({
                documentIssuanceCountry: value
              })}
            />
          </div>
          <div className={styles.input_container} style={errors ? { alignItems: 'flex-start' } : { alignItems: 'flex-end' }}>
            {passenger && passenger.requiredFields.includes('documentIssuanceDate') && <div className='simple-date-picker' style={{ flexGrow: '1' }}>
              <p className='datepicker-label'>تاريخ إصدار جواز السفر</p>
              <CustomDatePicker selected={passenger.documentIssuanceDate} onChange={(date) => handleChange({ documentIssuanceDate: date })} placeholderText="yyyy-mm-dd" dateFormat="yyyy-MM-dd" startDate={getYear(new Date())}
              />
              <span className="error-message">{errors[`${passenger.id}.documentIssuanceDate`]}</span>
            </div>}

            <div className='simple-date-picker' style={{ flexGrow: '1' }}>
              <p className='datepicker-label'>تاريخ إنتهاء جواز السفر</p>
              <CustomDatePicker selected={passenger.documentExpiryDate} onChange={(date) => handleChange({ documentExpiryDate: date })} placeholderText="yyyy-mm-dd" dateFormat="yyyy-MM-dd" startDate={getYear(new Date())}
              />
              <span className="error-message">{errors[`${passenger.id}.documentExpiryDate`]}</span>
            </div>
          </div>
        </div>
      </div>

      <p className={styles.container_title}>بيانات الأمتعة</p>
      <div className={classNames(styles.container, styles.input_container, styles.luggage_info_container)}>
        <p>الأمتعة المشمولة</p>
        {!passenger.freeBaggage.hold.count && !passenger.freeBaggage.carryOn.count && !passenger.freeBaggage.personalItem.count &&
          <p>لا تشمل هذه الرحلة أمتعة مشحونة أو حقائب محمولة</p>
        }

        {!!passenger.freeBaggage.hold.count && !passenger.freeBaggage.carryOn.count && !passenger.freeBaggage.personalItem.count &&
          <div className={styles.luggage_info}>
            <p>لا تشمل هذه الرحلة حقائب كابينة مجانية</p>
            <span className="iconify" data-icon={BAGS_TYPES.cabin_bag.icon}></span>
          </div>
        }

        {!!passenger.freeBaggage.hold.count && <FreeLuggage {...passenger.freeBaggage.hold} />}
        {!!passenger.freeBaggage.carryOn.count && <FreeLuggage {...passenger.freeBaggage.carryOn} />}
        {!!passenger.freeBaggage.personalItem.count && <FreeLuggage {...passenger.freeBaggage.personalItem} />}
      </div>
      {
        (passenger.extraBaggage.hold.length > 0 || passenger.extraBaggage.carryOn.length > 0) &&
        <p className={styles.container_title}>بيانات الأمتعه الإضافية</p> &&
        <LuggageInput
          passenger={passenger}
          currency={booking.currency}
          toggleBagSelect={toggleBagSelect}
        />
      }

    </form >
  );
};
const generatePassenger = (props) => {
  switch (props.passenger.passengerType) {
    case 'adult':
      return <BaseForm {...props} />;

    default:
      return <BaseForm {...props} />;
  }
};

const Passenger = ({
  passengers = [],
  status,
  booking = {},
  booking: { origin = {}, destination = {} } = {},
  handlePassengerChange,
  meta,
  goToSearch,
  toggleBagSelect,
  submit,
  error,
  errors,
  handleBookingChange
}) => {
  return (
    <>
      <div className={classNames(styles.container, styles.offer_main_information)}>
        <div className={styles.information_block}>
          <p>{origin.cityNameAr}</p>
          <div>
            <p>{origin.iataCode}</p>
            <p>{origin.nameAr}</p>
          </div>
        </div>

        <span className="iconify card_arrow reverse" data-icon="fluent:airplane-24-filled"></span>

        <div className={styles.information_block}>
          <p>{destination.cityNameAr}</p>
          <div>
            <p>{destination.iataCode}</p>
            <p>{destination.nameAr}</p>
          </div>
        </div>
      </div>

      <p className={styles.container_title}>نظرة عامة على تفاصيل الرحلة</p>

      <Slices
        mode="detailed"
        baggages={booking.baggages}
        slices={booking.slices}
        tripType={booking.tripType}
      />

      {
        passengers.map((passenger, index) => (
          generatePassenger({
            passenger,
            booking,
            meta,
            errors,
            order: index + 1,
            isFirstPassenger: index === 0,
            handleChange: update => handlePassengerChange(passenger.id, update),
            handleBookingChange: handleBookingChange,
            goToSearch,
            toggleBagSelect
          })
        ))
      }

      <div className={styles.container} style={{ justifyContent: 'space-between', textAlign: 'center' }}>
        <p className={styles.container_title}>هل ترغب في إضافة مسافر آخر؟</p>

        <button
          type="button"
          className="button"
          onClick={goToSearch}
        >
          عدِل بيانات الحجز
        </button>
      </div>

      <div className={!error && status != 'submitting' ? classNames(styles.steps_indicator_buttons, 'left-alined') : styles.steps_indicator_buttons}>
        {
          error &&
          <div className="error no-margin-top">
            <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
            <p>{error}</p>
          </div>
        }
        {
          status === 'submitting' &&
          <div className="hold-message no-margin-top">
            <span className="iconify" data-icon="zondicons:hour-glass"></span>
            <p>قد يستغرق إنشاء الحجز بضع ثواني, الرجاء عدم مغادرة الصفحة. </p>
          </div>
        }
        <button className="button" onClick={submit} disabled={status === 'submitting'}>
          التالي
          {status === 'submitting' ?
            <LoadingSpinner /> :
            <div>
              <span className="iconify" data-icon="ic:round-chevron-left"></span>
            </div>
          }
        </button>
      </div>
    </>
  );
};

export default Passenger;